import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { RightPanelType } from '../enums/right-panel-type.enum';

@Injectable({ providedIn: 'root' })
export class ComponentMessengerService {
    private rightPanelMessageSource: BehaviorSubject<RightPanelType> = new BehaviorSubject(
        RightPanelType.linkedTickets,
    );
    private ticketListMessageSource: BehaviorSubject<boolean> = new BehaviorSubject(false);

    newReplyMessage = new Subject<any>();
    showAllChatRepliesMessage = new Subject<void>();
    openNewsWidget = new Subject<any>();
    updateTeamMembers = new Subject<any>();
    ticketListMessage = this.ticketListMessageSource.asObservable();

    addNewReply(reply) {
        this.newReplyMessage.next(reply);
    }

    needToReload() {
        this.ticketListMessageSource.next(true);
    }

    open(type: RightPanelType) {
        this.rightPanelMessageSource.next(type);
    }

    showAllChatReplies(): void {
        this.showAllChatRepliesMessage.next();
    }

    teamMembersWereUpdated(teamMembers) {
        this.updateTeamMembers.next(teamMembers);
    }

    toggleDropdownChanged(isOpen) {
        this.openNewsWidget.next(isOpen);
    }
}
